import { clientRepo } from "~/server/apis/client_repo";
import { Product } from "~/server/types/search";
import { VoucherDetails } from "~/server/types/order";

export type ViewData = {
  product: Product | null;
  voucher: VoucherDetails | null;
};

export async function getViewData(): Promise<ViewData> {
  const [product, voucher] = await Promise.all([
    (async () => {
      try {
        const res = await clientRepo.getProductSearch({
          query: "",
        });
        return res?.data?.[0]?.products?.[0] ?? null;
      } catch (err) {
        console.error("home_indriya: getProductSearch failed", err);
        return null;
      }
    })(),
    (async () => {
      try {
        const res = await clientRepo.getLastNVouchers(1);
        return res?.[0] ?? null;
      } catch (err) {
        console.error("home_indriya: getLastNVouchers failed", err);
        return null;
      }
    })(),
  ]);

  return { product, voucher };
}
